module.exports = __webpack_public_path__ + "static/media/erpceshiliucheng.5f36bfa9.png";